import {
  PolicyContainer,
  PolicyTitle,
  PolicyText,
  PolicyList,
  PolicySectionTitle,
} from "styles/PolicyCommon";

const InboundPrivacy = () => {
  return (
    <PolicyContainer>
      <h1 className="hide">열달후에</h1>
      <PolicyTitle>개인정보 수집∙이용 및 제3자 제공 동의</PolicyTitle>

      <PolicySectionTitle>
        □ 개인정보의 수집∙이용에 관한 사항
      </PolicySectionTitle>
      <PolicyText>
        주식회사 커넥트아이 (이하“회사”)는 「개인정보보호법」, 「신용정보의 이용
        및 보호에 관한 법률」, 「정보통신망 이용촉진 및 정보보호 등에 관한
        법률」 등 관련 법규에 따라 귀하의 개인(신용)정보를 다음과 같이
        수집∙이용하고자 합니다.
      </PolicyText>

      <PolicySectionTitle>
        □ 개인(신용)정보의 수집∙이용 목적 및 항목
      </PolicySectionTitle>
      <PolicyList>
        <li>1. 수집 목적 : 보험상품 소개 및 상담 신청</li>
        <li>
          2. 수집 항목 :
          <PolicyList>
            <li>
              태아보험 상담 시<br />- 성명, 휴대전화번호, 이메일(아이디),
              생년월일, 태명, 출산예정일, 지역
            </li>
            <li>
              어린이보험 상담 시<br />- 성명, 휴대전화번호, 이메일(아이디),
              본인의 생년월일, 자녀의 생년월일, 지역
            </li>
          </PolicyList>
        </li>
        <li>3. 보유 및 이용 기간 : 1년</li>
      </PolicyList>

      <PolicySectionTitle>
        □ 개인(신용)정보의 제3자 제공에 관한 사항
      </PolicySectionTitle>
      <PolicyText>
        회사는 「개인정보보호법」, 「신용정보의 이용 및 보호에 관한 법률」,
        「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 관련 법규에 따라
        귀하의 개인(신용)정보를 다음과 같이 제3자에게 제공하고자 합니다.
      </PolicyText>

      <PolicySectionTitle>
        □ 개인(신용)정보를 제공받는 자의 이용 목적 및 항목
      </PolicySectionTitle>
      <PolicyList>
        <li>
          1. 제공받는 자 : 굿리치㈜ 및 굿리치㈜와 모집위탁계약을 체결한
          보험설계사, 대리점
        </li>
        <li>2. 제공받는 목적 : 보험상품 소개 및 상담신청</li>
        <li>
          3. 제공받는 항목 :
          <PolicyList>
            <li>
              태아보험 상담 시<br />- 성명, 휴대전화번호, 이메일(아이디),
              생년월일, 태명, 출산예정일, 지역
            </li>
            <li>
              어린이보험 상담 시<br />- 성명, 휴대전화번호, 이메일(아이디),
              본인의 생년월일, 자녀의 생년월일, 지역
            </li>
          </PolicyList>
        </li>
        <li>4. 보유 및 이용 기간 : 1년</li>
      </PolicyList>

      <PolicySectionTitle>
        □ 동의를 거부하는 경우에 대한 안내
      </PolicySectionTitle>
      <PolicyText>
        보험 전문가 상담을 위한 필수적인 동의이므로, 동의를 하지 않으면 해당
        서비스를 이용하실 수 없습니다.
      </PolicyText>

      <PolicySectionTitle>□ 동의 철회를 위한 안내</PolicySectionTitle>
      <PolicyText>
        본 동의를 하시더라도 앱 내 마이메뉴&gt;1:1문의 또는 당사
        고객센터(after10month@connect-i.co.kr)를 통해 동의를 철회하거나 가입
        안내 목적의 연락에 대한 중단을 요청하실 수 있습니다.
      </PolicyText>
    </PolicyContainer>
  );
};

export default InboundPrivacy;
